import { Provider as StoreContextProvider } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Route, Routes } from 'react-router';
import * as Sentry from '@sentry/react';

import { history } from '@/utils/navigation';
import { store } from '@/store';

import DayContextProvider from '@/contexts/providers/day';
import SubscriptionContextProvider from '@/contexts/providers/subscription';
import ThemeContextProvider from '@/contexts/providers/theme';

import { Admin, Root } from '@/pages';

import Router from '@/Router';

import { ROUTES } from '@/constants/routes';

import '@/styles/fonts.css';

Sentry.init({
  dsn: import.meta.env.VELA_SENTRY_DSN,
  environment: import.meta.env.MODE,
});

export default function App() {
  return (
    <StoreContextProvider store={store}>
      <DndProvider backend={HTML5Backend}>
        <SubscriptionContextProvider>
          <Router history={history}>
            <ThemeContextProvider>
              <DayContextProvider>
                <Routes>
                  <Route path={`${ROUTES.ADMIN.ROOT}${ROUTES.WILDCARD}`} Component={Admin} />
                  <Route path={ROUTES.WILDCARD} Component={Root} />
                </Routes>
              </DayContextProvider>
            </ThemeContextProvider>
          </Router>
        </SubscriptionContextProvider>
      </DndProvider>
    </StoreContextProvider>
  );
}
